export default __webpack_public_path__ + "static/media/b.34a71e4f.svg";